import posthog from 'posthog-js';

// Initialize PostHog
const POSTHOG_API_KEY = process.env.REACT_APP_POSTHOG_API_KEY;
const POSTHOG_HOST = 'https://app.posthog.com';

let initialized = false;

export const initAnalytics = () => {
    if (!POSTHOG_API_KEY) {
        console.warn('PostHog API key not found. Analytics will not be tracked.');
        return;
    }

    if (!initialized) {
        posthog.init(POSTHOG_API_KEY, {
            api_host: POSTHOG_HOST,
            autocapture: false, // Disable autocapture for more control
            capture_pageview: false, // We'll manually track page views
        });
        initialized = true;
    }
};

export const identifyUser = (userId, traits = {}) => {
    if (!initialized) return;
    posthog.identify(userId, traits);
};

export const trackEvent = (eventName, properties = {}) => {
    if (!initialized) return;
    posthog.capture(eventName, properties);
};

// Specific event tracking functions
export const trackSignup = (userId, email) => {
    trackEvent('signup_created', { userId, email });
};

export const trackFlowCreated = (projectId, projectName, method = 'manual') => {
    trackEvent('flow_created', { projectId, projectName, method });
};

export const trackScreenAdded = (projectId, screenCount) => {
    trackEvent('screen_added', { projectId, screenCount });
};

export const trackPreviewOpened = (projectId, method = 'qr_code') => {
    trackEvent('preview_opened', { projectId, method });
};

export const trackSDKInstalled = (projectId) => {
    trackEvent('sdk_installed', { projectId });
};

export const trackOnboardingStart = (projectId) => {
    trackEvent('onboarding_start', { projectId });
};

export const trackFlowPublished = (projectId, projectName) => {
    trackEvent('flow_published', { projectId, projectName });
};

export const trackAIScreenGenerated = (projectId, prompt, screenCount) => {
    trackEvent('ai_screen_generated', { projectId, prompt, screenCount });
};
